/* eslint-disable no-underscore-dangle */
import axios, { AxiosError, AxiosResponse } from "axios";
import {
  HealthCheckEvents,
  ILogHealthCheckDataReq,
  IRestServices,
} from "./types";

import GuOAuth from "./modules/guOAuth";
import LogHealthCheck from "./modules/logHealthCheck";
import EventEmitter from "events";
import bind from "bind-decorator";

export default class Api extends EventEmitter {
  /**
   * Get singleton Api instance
   * @returns {Api}
   */

  public static get instance(): Api {
    this._instance = this._instance || new Api();

    return this._instance;
  }

  private static _instance: Api;
  private static _defaultPageId = "60024_vk";
  private static _baseURL = 'https://www.gosuslugi.ru/api/vk-api';
  private static _baseHealthCheckUrl = 'https://www.gosuslugi.ru/health';

  public static updateHealthUrl(baseURL: string) {
    this._baseHealthCheckUrl = baseURL;
    this.instance.restServices.health = this.instance.healthCheckAxios;
  }

  public static updateBaseUrl(baseURL: string) {
    this._baseURL = baseURL;
    this.instance.restServices.root = this.instance.rootAxios;
  }

  private restServices: IRestServices = {
    root: this.rootAxios,
    health: this.healthCheckAxios,
  };

  public cookie: string | undefined;

  @bind
  private onResponseError(error: Error | AxiosError) {
    const params: Record<string, string | number> = {
      errorMessage: error.message,
    };

    if (axios.isAxiosError(error)) {
      params.status = error.response.status;
      params.url = error.response.config.url;
      params.data = error.response.data;

      if (error.response?.status === 401) {
        this.emit("logout");
      }
    }

    Api.healthCheckFor(HealthCheckEvents.errorResponse).sendFailure(
      JSON.stringify(params)
    );

    return Promise.reject(error);
  }

  public static healthCheckFor(
    event: HealthCheckEvents,
    pageId: string = Api._defaultPageId
  ): LogHealthCheck {
    return new LogHealthCheck(this.instance.restServices, {
      event,
      pageId: pageId as ILogHealthCheckDataReq["pageId"],
    });
  }

  public get get() {
    return this.restServices.root.get;
  }

  public get post() {
    return this.restServices.root.post;
  }

  public get rootAxios() {
    const instance = axios.create({
      baseURL: Api._baseURL,
      withCredentials: true,
    });

    instance.interceptors.response.use(
      v => v,
      this.onResponseError
    );

    return instance;
  }

  public get healthCheckAxios() {
    const instance = axios.create({
      baseURL: Api._baseHealthCheckUrl,
      withCredentials: true,
    });

    return instance;
  }

  public static hasApiError(error: unknown): boolean {
    return axios.isAxiosError(error);
  }

  guOAuth: GuOAuth = new GuOAuth(this.restServices);
}
